import React from 'react';
import { Link } from 'react-router-dom';

export default function Breadcrumb({ title }) {
  // Segmentamos la URL, p.ej. "/blog/page/2/" -> ["blog", "page", "2"]
  const pathSegments = window.location.pathname
    .split('/')
    .filter(segment => segment !== '');

  /*
    Lógica de filtrado:
    - Si es "page" y va seguido de un número, omitimos "page" y conservamos ese número.
    - Si es "page" sin número, también se omite "page".
    - En cualquier otro caso, se conserva el segmento tal cual.
  */
  const filteredSegments = [];
  for (let i = 0; i < pathSegments.length; i++) {
    const segment = pathSegments[i].toLowerCase();

    if (segment === 'page') {
      // ¿Existe un siguiente segmento?
      if (i + 1 < pathSegments.length) {
        const nextSegment = pathSegments[i + 1];
        // ¿Es un número?
        if (/^\d+$/.test(nextSegment)) {
          // Conservamos el número (omitimos "page")
          filteredSegments.push(nextSegment);
          i++; // Saltamos el siguiente
        } else {
          // "page" seguido de algo que NO es un número => omitimos "page"
          // (Si prefieres conservarlo, reemplaza con filteredSegments.push('page'))
        }
      } else {
        // "page" es el último segmento => lo omitimos
      }
    } else {
      // Segmento normal => se conserva
      filteredSegments.push(pathSegments[i]);
    }
  }

  // Función para reconstruir una parte de la URL
  const buildPath = (segments) => {
    return `/${segments.join('/')}/`.replace(/\/\/+/g, '/');
  };

  return (
    <div className="container">
      <ol className="breadcrumb text-capitalize">
        {/* HOME */}
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>

        {/* Mostrar cada segmento filtrado */}
        {filteredSegments.map((segment, index) => {
          const segmentsUpToIndex = filteredSegments.slice(0, index + 1);
          const path = buildPath(segmentsUpToIndex);

          // Capitalizamos el texto si es una palabra (si es número, quedará igual)
          const label = segment.charAt(0).toUpperCase() + segment.slice(1);

          if (index < filteredSegments.length - 1) {
            return (
              <li key={index} className="breadcrumb-item">
                <Link to={path}>{label}</Link>
              </li>
            );
          }
          return (
            <li key={index} className="breadcrumb-item active" aria-current="page">
              {label}
            </li>
          );
        })}
      </ol>
      <div className="cs_height_18" />
      <h1 className="cs_fs_72 mb-0 text-color-gblue">{title}</h1>
    </div>
  );
}
